<template>
	<div :class="getClassName">
		<div class="item">
			<content-loader
				viewBox="0 0 400 500"
				:speed="2"
				primaryColor="#f3f3f3"
				secondaryColor="#ecebeb"
			>
				<rect x="0" y="0" rx="0" ry="0" width="400" height="292" />
				<rect x="20" y="325" rx="0" ry="0" width="85" height="13" />
				<rect x="20" y="349" rx="0" ry="0" width="297" height="19" />
				<rect x="20" y="379" rx="0" ry="0" width="293" height="31" />
				<rect x="20" y="427" rx="0" ry="0" width="73" height="40" />
			</content-loader>
		</div>
	</div>
</template>

<script>
	import {ContentLoader} from "vue-content-loader";
	export default {
		components: {ContentLoader},
		props: ["className"],
		computed: {
			getClassName() {
				return this.className || "col-lg-4 col-md-6 col-sm-6";
			},
		},
	};
</script>

<style></style>
